import { getM3LevelOfDifficultyName } from '../autogen/bundle.js';
import { getEnumM3SeqABTestAudienceTagName } from '../autogen/bundle.js';
import { isRoleAdmin   } from '../util.js';
import { getProtoAlias } from '../util.js';

export const MAIN_SEQUENCE_PROTO_ID = 216969754;

/**
 * @typedef {Object} LevelObject
 * @property {number} number
 * @property {RevisionObject[]} revisions
 * 
 * @typedef {Object} RevisionObject
 * @property {RevisionIdObject} id
 * @property {string} levelProtoName
 * @property {number} difficulty
 *
 * @typedef {Object} RevisionIdObject
 * @property {number} sequenceProtoId
 * @property {number} number
 * @property {number} protoId
 * @property {number} revision
 */


 /**
 * @typedef {Object} SequenceNameInfo
 * @property {number} id
 * @property {string} name
 */

export const PERIOD_NAME_7_DAYS = '7days';

export class SequenceFragmentId {
  /**
   * @param {number} sequenceProtoId
   */
  constructor(sequenceProtoId) {
    this.sequenceProtoId = sequenceProtoId;
  }
}

export class LevelId {
  /**
   * @param {number} sequenceProtoId
   * @param {number} number
   */
  constructor(sequenceProtoId, number) {
    this.sequenceProtoId = sequenceProtoId;
    this.number          = number;
  }
}

//-----------------------------------------------------------------------------

export class LevelVarId {
  /**
   * @param {number} sequenceProtoId
   * @param {number} number
   * @param {number} protoId
   */
  constructor(sequenceProtoId, number, protoId) {
    this.sequenceProtoId = sequenceProtoId;
    this.number          = number;
    this.protoId         = protoId;
  }
}

/**
 * @param {number} levelProtoId
 * @return {string}
 */
export function getLevelVarName(levelProtoId) {
  const alias = getProtoAlias(levelProtoId);

  const PREFIX = '@m3/levels/';
  if(alias.startsWith(PREFIX)) {
    return alias.substring(PREFIX.length);
  }
  return alias;
}

//-----------------------------------------------------------------------------

export class RevisionId {
  /**
   * @param {number} sequenceProtoId
   * @param {number} number
   * @param {number} protoId
   * @param {number} revision
   */
  constructor(sequenceProtoId, number, protoId, revision) {
    this.sequenceProtoId = sequenceProtoId;
    this.number          = number;
    this.protoId         = protoId;
    this.revision        = revision;
  }
}

export function convertLevelIDObjToRevisionId(levelIDObj) {
  return new RevisionId(
    levelIDObj.SequenceProtoID,
    levelIDObj.Number,
    levelIDObj.ProtoID,
    levelIDObj.Revision,
  );
}

// TODO: del
export function convertRevisionIdToLevelIDObj(revisionId) {
  return {
    SequenceProtoID: revisionId.sequenceProtoId,
    Number:          revisionId.number,
    ProtoID:         revisionId.protoId,
    Revision:        revisionId.revision,
  };
}

export function getDifficultyShortName(code) {
  switch(code) {
    case 0: return '';
    case 1: return 'hard';
    case 2: return 'very hard';
  }

  return getM3LevelOfDifficultyName(code);
}

export function getDifficultyName(code) {
  switch(code) {
    case 0: return 'нормально';
    case 1: return 'сложно';
    case 2: return 'очень сложно';
  }

  return getM3LevelOfDifficultyName(code);
}

export const REVISION_STATE_ACTIVE   = 0;
export const REVISION_STATE_INACTIVE = 1;

export function isRevisionActive(state) {
  return state === REVISION_STATE_ACTIVE;
}

export function getRevisionStateClass(state) {
  return {
    activeRevision: isRevisionActive(state),
  };
}

export function getRevisionStateName(code) {
  switch(code) {
    case 0: return 'активная ревизия';
    case 1: return 'неактивная ревизия';
  }

  return 'Неизвестное состояние ' + code;
}

export function getAudienceName(code) {
  if(code === null || code === 0) {
    return 'все';
  }
  return getEnumM3SeqABTestAudienceTagName(code);
}

export function getPassRateColor(passRatePercent, difficulty, minPassRateConfs) {
  const minPassRateConf = findMinPassRateConf(minPassRateConfs, difficulty);
  if(minPassRateConf === null) {
    return null;
  }

  if(passRatePercent >= minPassRateConf.value) {
    return null;
  }

  return minPassRateConf.warning_color;
}

function findMinPassRateConf(minPassRateConfs, difficulty) {
  if(minPassRateConfs === null) {
    return null;
  }

  if(minPassRateConfs.length === 0) {
    return null;
  }

  for(const minPassRateConf of minPassRateConfs) {
    if(minPassRateConf.difficulty === difficulty) {
      return minPassRateConf;
    }
  }
  return null;
}

export function mayReadM3Stat(role) {
  return isRoleAdmin(role);
}

export function mayManageM3Stat(role) {
  return isRoleAdmin(role);
}

export function getSequenceShortName(sequence) {
  switch(sequence.id) {
    case 216969754: return 'story';                   // @story/prototype/levels

    case 111196281: return 'mesa/kid';                // @mesa/foster_kid/m3_levels
    case 110519564: return 'mesa/kid/new_1';          // @mesa/foster_kid/m3_levels_new_1
    case 253450697: return 'mesa/kid/new_2';          // @mesa/foster_kid/m3_levels_new_2
    case 252091246: return 'mesa/kid/since_710';      // @mesa/foster_kid/m3_levels_since_710

    case 221454860: return 'mesa/horoscope_1';        // @mesa/horoscope/m3_levels_horoscope_01_aries22
    case  37970615: return 'mesa/horoscope_2';        // @mesa/horoscope/m3_levels_horoscope_02
    case  87586548: return 'mesa/horoscope_3';        // @mesa/horoscope/m3_levels_horoscope_03
    case  22616893: return 'mesa/horoscope_4';        // @mesa/horoscope/m3_levels_horoscope_04
    case 102895486: return 'mesa/horoscope_5';        // @mesa/horoscope/m3_levels_horoscope_05
    case 263140283: return 'mesa/horoscope_6';        // @mesa/horoscope/m3_levels_horoscope_06
    case 148121592: return 'mesa/horoscope_7';        // @mesa/horoscope/m3_levels_horoscope_07
    case 124643369: return 'mesa/horoscope_8';        // @mesa/horoscope/m3_levels_horoscope_08
    case   1506410: return 'mesa/horoscope_9';        // @mesa/horoscope/m3_levels_horoscope_09
    case  58138895: return 'mesa/horoscope_10';       // @mesa/horoscope/m3_levels_horoscope_10
    case  67908940: return 'mesa/horoscope_11';       // @mesa/horoscope/m3_levels_horoscope_11
    case 226560393: return 'mesa/horoscope_12';       // @mesa/horoscope/m3_levels_horoscope_12

    case 6391293:   return 'mesa/nestling';           // @mesa/nestling/m3_levels
    case 161451700: return 'mesa/nestling/since_710'; // @mesa/nestling/m3_levels_since_710
  }

  return sequence.name;
}
